import { render } from "./DynamicTextArea.vue?vue&type=template&id=e30478ee&ts=true"
import script from "./DynamicTextArea.vue?vue&type=script&lang=ts"
export * from "./DynamicTextArea.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\benja\\Desktop\\LolaClean\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__